import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

const productionClient = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  useCdn: process.env.NODE_ENV === 'production',
  apiVersion: '2021-03-25',
})

export function getClient() {
  return productionClient
}

export function getImageUrlFor(src: string) {
  const client = getClient()
  return imageUrlBuilder(client).image(src)
}
